export default {
    login: 'Se connecter',
    logout: 'Se déconnecter',
    register: 'Créer un compte',
    upload: 'Télécharger',
    name: 'Nom',
    email: 'Adresse électronique',
    password: 'Mot de passe',
    passwordConfirmation: 'Confirmation du mot de passe',
    isCommunityManager: 'Community Manager',
    dashboard: 'Tableau de bord',
    offerLists: 'Liste des offres',
    schedule: 'Calendrier',
    accountEdit: 'Modifier le compte',
    edit: 'Modifier',
    detail: 'Détail',
    fullname: '{{lastname}} {{firstname}}',
    quantity: 'Quantité',
    quantityWithWeight: 'Quantité (Poids)',
    confirmTitle: 'Confirmer',
    orderInformation: 'Information des réservations',
    orderPrices: 'Historique des variations de prix',
    invoices: 'Factures',
    contact: 'Contact',
    when: 'Date',
    add_to_google_calendar: 'Ajouter à Google Agenda',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: 'Télécharger le fichier CSV',
            producer: 'Producer',
            download: 'Le fichier CSV modèle est disponible.',
            sampleDeliveryDateMemo: "doit être au moins 14 jours après la date souhaitée pour commencer l'offre",
            uploadMemo: 'Nous vous contacterons après le téléchargement',
            suggestToCreateBankAccountText: "Afin de pouvoir encaisser une vente, vous devez indiquer votre compte bancaire.\nCette information est demand\u00E9e lors qu\u2019un Sales Contract est fait. Nous vous conseillons donc de l\u2019enregistrer quand vous t\u00E9l\u00E9chargez la liste d\u2019offre.",
        },
        offerList: {
            title: 'List des offres de {{country}}/{{ name }}',
            createInvoices: 'Emettre une facture',
            createInvoicesExplanation: "Nous \u00E9mettons une seule facture pour les r\u00E9servations enregistr\u00E9es dont le d\u00E9lai de paiement est \u00AB 1. la facture forfaitaire selon les souhaits du producteur \u00BB.\nToutefois, une nouvelle facture ne sera pas cr\u00E9\u00E9e pour les r\u00E9servations pour lesquelles une facture a d\u00E9j\u00E0 \u00E9t\u00E9 \u00E9mise.\nL'URL de la facture \u00E9mise sera communiqu\u00E9e par courriel \u00E0 chaque torr\u00E9facteur.",
            sampleOrderStock: {
                quantity: "Attribution du stock d'échantillons",
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: 'Pays de vente',
            basicInformations: 'Informations générales',
            publishedCountriesTable: 'Pays de vente',
            transportToWarehouseTable: 'Information de transport pour chaque entrepôt',
            officeDetailTable: 'Office Information',
            offersTable: 'Offers',
            contracts: 'Contracts',
            sampleOrderPeriod: "Demande d'échantillons ouverte",
            orderPeriod: 'Réservation ouverte',
            paymentPeriod: 'Calendrier des paiements',
            estimatedDeliveryPeriod: 'Date de livraison prévue',
            paymentAfterDelivery: 'Paiement différé après la réception des marchandises',
            paymentPeriods: {
                reserved: 'Prépaiement lors de la réservation',
                exported: 'Paiement lors de l’expédition',
                imported: 'Paiement lors de l’arrivée au port',
                delivered: 'Lors de la livraison au torréfacteur',
            },
            installmentPaymentAfterImport: "Paiement échelonné après l'entrée en entrepôt",
            installmentPayment: 'paiement échelonné',
            estimatedPaymentDateFormat: '{{date}} {{month}} {{year}}',
            installmentPaymentsHelp: {
                title: 'Par rapport au paiement différé',
                body: "Si vous choisissez \"paiement diff\u00E9r\u00E9\" lors de la r\u00E9servation, vous pouvez effectuer votre paiement apr\u00E8s la r\u00E9ception des marchandises.\nIl y a deux options :\n- paiement comptant lors de la premi\u00E8re livraison\n- paiement \u00E0 chaque\"",
            },
            FreeOnBoardHelp: {
                title: "Qu'est-ce que le FOB ? ",
                body: "Il signifie le prix de grain de caf\u00E9 vert au moment de l'arriv\u00E9e au port dans un pays d'origine.\nLes frais de transport maritime et ceux d'importation ne sont pas inclus.",
            },
            estimatedDeliveryPeriodFormat: '{{monthPart}} {{month}} {{year}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: 'Modifier votre profil',
            subTitle: 'Vos informations',
            questionnairesForRoaster: 'Enquête sur les machines de torréfaction',
            questionnairesForRoasterMemo: '* Vous pouvez modifier vos réponses ultérieurement.',
            cannotChangeCountry: "* Veuillez noter qu'une fois que votre pays est enregistré, vous ne pouvez plus le modifier",
        },
        editAccount: {
            title: 'Modifier les informations du compte',
            currentEmail: 'Adresse électronique actuelle',
            warning: "Apr\u00E8s avoir modifi\u00E9 votre adresse \u00E9lectronique, vous serez d\u00E9connect\u00E9.\nComme un lien de confirmation sera envoy\u00E9 \u00E0 votre nouvelle adresse,\ncliquez sur le lien indiqu\u00E9 afin de finaliser la modification.\nVous pourrez alors vous connecter avec votre nouvelle adresse.",
        },
        exchangeRates: {
            title: 'Fixer le taux de change',
            exchangeRateColumnTitle: 'USD/{{ currency }} Conversion',
        },
        roasterOfferLists: {
            sampleRequest: "Demande d'échantillons",
            order: 'Réservation',
            inactive: 'Liste des offres déjà fermée',
        },
        roasterOrder: {
            title: 'Réservation de {{ listName }}',
            explanationSelectOffers: '・Veuillez saisir le nombre de réservation après avoir confirmé le nombre du stock indiqué ci-dessous.',
            explanationAuctionWithFobPriceUsdPerLb: '* Les résultats des enchères sont en USD/kg. (1kg=2.20462lb)',
            explanationStockMightChange: "* Veuillez noter qu'il est possible que nous soyons en rupture de stock pendant que vous gérez cette page.",
            order: 'Réservation',
            orderAmount: 'Réservation',
            totalFee: 'Total : {{ fee }} (TTC)',
            totalBags: 'Nombre de conditionnements: {{ amount }}',
            totalOrderedBags: 'Nombre du conditionnement commandé: {{ amount }}',
            totalWeight: 'Poids total: {{ weight }} kg',
            totalOrderedWeight: 'Poids commandé: {{ weight }} kg',
            totalOneTimeUpfrontOrderedBags: 'Nombre du conditionnement prépayé: {{ amount }} ',
            typicaHandlingFee: 'Commission pour TYPICA: {{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: "Jusqu'à 4 conditionnements: {{ lessThan5Bags }}, de 5 à 9 conditionnements: {{ moreThan5Bags }}, de 10 à 49 conditionnements: {{ moreThan10Bags }}, 50 conditionnements ou plus: {{ moreThan50Bags }}",
            typicaHandlingFeeExplanationByWeight: 'Moins de 300 kg: {{ lessThan300Kg }} / 300 kg ou plus: {{ moreThan300Kg }} / 600 kg ou plus: {{ moreThan600Kg }} / 3,000 kg ou plus: {{ moreThan3000Kg }}',
            details: 'Détail',
            paymentAndDelivery: 'Mode de paiement et livraison',
            paymentMethodExplanation: "* Le plafond de carte de cr\u00E9dit et les conditions de paiement varient selon les clients. Veuillez contacter votre banque pour plus de d\u00E9tails.\n        * Lors que le montant de votre achat d\u00E9passe huit chiffres, le mode paiement se peut \u00EAtre le virement bancaire. Nous vous remercions de votre compr\u00E9hension.",
            endOfMonth: "Jusqu'à fin",
            oneTimeUpfrontExplanations: "- Le paiement doit être effectué avant la {{ paymentDate }}. Pour plus d'informations, veuillez consulter la facture émise après la fin de l'offre.",
            afterImportPaymentExplanations: "- Le paiement est d\u00FB dans un d\u00E9lai de 14 jours \u00E0 compter de la date d'entr\u00E9e du caf\u00E9 dans l'entrep\u00F4t (Date approximative: {{ deliveryPeriod }}).\n      - Les marchandises peuvent \u00EAtre livr\u00E9es une fois le paiement effectu\u00E9.",
            fewTimesPaymentAfterImportExplanations: "- Le premier paiement est d\u00FB dans les 14 jours suivant la date d'entr\u00E9e du caf\u00E9 dans l'entrep\u00F4t (Date approximative: {{ deliveryPeriod }}).\n      - Les marchandises peuvent \u00EAtre livr\u00E9es apr\u00E8s le premier paiement.\n      - Le deuxi\u00E8me paiement et les paiements suivants sont dus \u00E0 la fin du mois suivant l'entr\u00E9e en entrep\u00F4t. Pour plus de d\u00E9tails, voir la facture \u00E9mise au d\u00E9but du mois.",
            paymentTimingExplanation: '* Les frais changent en fonction du moment du paiement. Veuillez vous référer au simulateur de prix en bas de la page pour plus de détails.',
            oneTimeUpfrontRateConstraintByBagAmount: ' (uniquement lors de réservations de 2 sacs ou plus)',
            oneTimeUpfrontRateConstraintByWeight: ' (Uniquement pour les réservations de 120 kg ou plus)',
            deliveryMethodExplanation: "* Des frais de stockage mensuels de {{unitPrice}} par kg sont factur\u00E9s \u00E0 partir du premier jour du deuxi\u00E8me mois suivant la date d'entr\u00E9e dans notre entrep\u00F4t.",
            oneTimeUpfrontRateByBagAmount: '(Une remise de {{ percentage }} * uniquement lors de réservations de 2 sacs ou plus)',
            oneTimeUpfrontRateByWeight: ' | (Une remise de -{{ percentage }})',
            paymentTimingNegativeRate: ' | (Une remise de -{{ percentage }})',
            paymentTimingPositiveRate: ' | ({{ positive }}{{ percentage }} de commission)',
            addressExplanation: "* N'oubliez pas de saisir le numéro de l'appartement et / ou le nom du bâtiment, etc.",
            emailExplanation: "* Veuillez vérifier que l'adresse électronique est correcte.",
            deliveryTimeEtcExplanation: "* Veuillez noter qu'il est possible que nous ne soyons pas en mesure de répondre à toutes vos demandes comme l'heure de livraison, par exemple.",
            sample: 'Échantillon',
            sampleOrder: "Demande d'échantillons",
            sampleOrdered: 'Réservé',
            outOfSamples: 'Out of samples',
            bidSubmitted: 'Déjà adjugé',
            sampleOrderableCount: "Nombre de lot d'échantillons qu'il est possible de demander",
            inputAddress: 'Saisir votre adresse',
            simulateAndInputAddress: 'Voir le détail du prix et saisir votre adresse',
            simulation: 'Faire une simulation de prix',
            sampleOrderCaption: "Réserver l'échantillon du lot ci-dessous",
            comment: 'Commentaire',
            commentHelp: "* Votre commentaire sera partagé avec des producteurs et d'autres torréfacteurs",
            translation: '* Les commentaires peuvent être traduits en anglais, en espagnol, en japonais, en chinois ou en coréen.',
            postComment: 'Laisser un commentaire',
            updateComment: 'Modifier votre commentaire',
            deleteComment: 'Supprimer votre commentaire',
            noComments: 'Pas de commentaires',
            cuppingScoreHelpText: 'Veuillez saisir la note que vous avez mise sur le formulaire de la SCA cupping',
            more: 'Voir plus',
            ordered: 'Réservé',
            addInvoice: 'Emettre une facture',
            preOrderExplanation: "Durée de réservation estimée est à partir de {{startedAt}} -jusqu'à {{endedAt}}.",
            countdownToOrder: "Il vous reste  {{countdown}} jusqu'à l'ouverture des réservations",
            confirmationOfBuyPartial: "Si le Lot:{{lotNumber}} est inférieur à la quantité que je souhaite, je ne l'achète pas aux enchères.",
            auctionBadgeExplanation: "Ce lot est mis \u00E0 la vente aux ench\u00E8res \u00E0 l'aveugle.\nVeuillez indiquer le prix d'achat et la quantit\u00E9 de lots souhait\u00E9s.\nLa diff\u00E9rence entre le prix que vous proposez et le prix initial sera vers\u00E9 au producteur en tant que prime d'ench\u00E8re.\nLes r\u00E9sultats de la vente aux ench\u00E8res vous seront envoy\u00E9s par courriel.\nLe chiffre sur le badge indique le nombre de lots actuellement demand\u00E9.",
            okagesamaNoMoriPrice: '* Frais de participation {{ priceUsd }} (environ {{ price }})',
            okagesamaNoMoriPriceText: '(Les frais de participation peuvent différer en fonction du taux de change.)',
            sampleStats: 'Torréfacteurs sont intéressés',
            preorderStats: 'Achats par les torréfacteurs',
        },
        ordersPage: {
            title: 'Liste des réservations',
            detailsTitle: 'Pre-ordered offer lists',
        },
        sampleOrdersPage: {
            title: "Liste de demande d'échantillons",
        },
        register: {
            accept: "Accepter les conditions d'utilisation",
        },
        orderedOfferLists: {
            title: 'Liste des offres réservées',
        },
        sampleOrders: {
            title: "Liste de demande d'échantillons",
            import: "Importer la demande d'échantillons",
        },
        sampleOrderedOfferLists: {
            title: "Liste des offres de demandes d'échantillons",
        },
        orderDetail: {
            orderItemsTableTitle: 'Liste de lots réservés',
            bidsTableTitle: 'Liste de lots adjugés',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: 'Créer ou modifier une demande',
        },
        sampleOrderDetail: {
            requestedLotNumbers: "Lot# dont l'échantillon vous avez demandé",
        },
        invoice: {
            title: 'Facture pour la réservation {{orderIds}}',
            billingTo: 'Nom de facturation',
            billingAddress: 'Adresse de facturation',
            transparencyInformation: {
                farm: 'Producteur',
                farmExplanation: 'Veuillez suivre ce <1>lien</1> pour obtenir des informations sur le producteur.',
                mill: "Site d'extraction",
                millExplanation: "Les cerises ou les parches de café achetées auprès de petits producteurs sont raffinées dans des sites d'extration locaux. Ce prix comprend les frais de transport à l'intérieur du pays de production et également les frais de dédouanement.",
                auctionBonus: "Prime d'enchère",
                auctionBonusExplanation: "Il s'agit de la différence entre le prix d'achat de l'enchères à l'aveugle et le prix initial. Ce montant sera versé au producteur en tant que prime d'enchère.",
                shippingFee: 'Frais de transport',
                shippingFeeExplanation: "Il s'agit du montant total des frais de transport et d'importation (dédouanement, frais de demande du certificat phytosanitaire, etc.).",
                importTax: 'VAT à l’importation',
                importTaxExplanation: 'Cela représente {{ importTaxRate }} du total des frais de transport et du prix de la marchandise.',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'Il s’agit de la rémunération de TYPICA. ({{exclusiveTypicaHandlingRate}})',
                typicaExplanationByBagCount: "Il s'agit des commissions de TYPICA. (Jusqu'à 4 conditionnements : {{ lessThan5Bags }}, de 5 à 9 conditionnements : {{ moreThan5Bags }}, de 10 à 49 conditionnements : {{ moreThan10Bags }}, 50 conditionnements ou plus : {{ moreThan50Bags }})",
                typicaExplanationByWeight: 'Il s’agit de la rémunération de TYPICA. (Moins de 300 kg: {{ lessThan300Kg }}, 300 kg ou plus: {{ moreThan300Kg }}, 600 kg ou plus: {{ moreThan600Kg }}, 3,000 kg ou plus: {{ moreThan3000Kg }})',
                typicaExplanationForTypicaSelection: 'Il s’agit de la rémunération de TYPICA. (40%)',
                typicaExplanationForTypicaSelectionByWeightV1: 'Il s’agit de la rémunération de TYPICA. (Moins de 300 kg: 40%, 300 kg ou plus: 35%, 600 kg ou plus: 30%, 3,000 kg ou plus: 25%)',
                typicaExplanationForTypicaSelectionByWeightV2: 'Il s’agit de la rémunération de TYPICA. (Moins de 300 kg: 35%, 300 kg ou plus: 25%, 600 kg ou plus: 20%, 3,000 kg ou plus: 15%)',
                consumptionTaxExplanation: "Il s'agit des coûts taxables et les frais {{ taxRate }}.",
                vatReverseChargeExplanation: "L'autoliquidation de la TVA (0 %) est appliquée.",
                oldPriceVersionKgPriceNotice: "Il s'agit du prix au kg après soustraction des « Frais de paiement différé (non taxables), Paiement à l'avance remise » et « les frais de service (non taxables) ».",
                newPriceVersionKgPriceNotice: 'Il s’agit du prix au kg sans « Réduction ou frais en fonction du moment du paiement ».',
                specialTypicaDiscount: 'Discount',
                specialTypicaDiscountExplanation: 'This is the total discount amount.',
                shippingFeeForJp: 'Frais d’expédition à l’étranger',
                shippingFeeExplanationForJp: 'Le coût du port de chargement au port/aéroport de débarquement.',
                importTaxForJp: 'Frais d’importation et de transport',
                importTaxExplanationForJp: 'Il s’agit du montant total des frais d’importation et de transport (frais de douane, frais de demande de quarantaine pour les végétaux, etc.) entre le port de déchargement et l’entrepôt.',
                consumptionTaxExplanationForJp: 'Il s’agit du montant imposable total qui est de 8 % pour les grains de café vert et de 10 % pour les frais d’expédition à l’étranger et autres frais.',
                CoffeeCherryExplanation: 'Remarks',
                negativeBreakdownCoffeeCherryExplanation: 'As the cost of cherries of in Ethiopia continues to rise, it becomes increasingly difficult for washing stations, mills and exporters to stay profitable. {{producerName}}, however, believes that building long-term partnerships with roasters is important in the overall sustainability of the industry and so, in valuing those relationships, will be offering their coffee at an average price of the last few years, rather than raising it significantly.',
            },
            paidStatus: 'Statut du paiement',
            paidMessage: 'Déjà payé au {{paidDate}}',
            unpaidMessage: 'Veuillez payer avant le {{expiredDate}}',
            changePaymentMethod: 'Changer le mode de paiement',
            vatrcHelp: "L'autoliquidation de la TVA sera appliquée lorsque le numéro de TVA est saisi dans l'écrit de profil.",
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: 'Liste des torréfacteurs',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: 'Liste des producteurs',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: "Information du pays d'origine",
        },
        roasterCountries: {
            title: 'Pays de vente',
        },
        adminOrder: {
            title: 'Réservation par un mandataire',
            selectRoaster: 'Sélectionnez un torréfacteur',
        },
        warehouses: {
            title: "Gestion d'entrepôt",
        },
        warehouseItems: {
            title: "Stock d'entrepôt",
            deliveryRequest: 'Demande de livraison',
            addressInfo: 'Adresse de livraison',
            selectItems: 'Sélectionnez un Lot dont vous souhaitez demander la livraison',
            explainationForQuantity: "Les quantités indiquées sont basées sur le nombre de conditionnements. Veuillez noter qu'ils sont indiqués différemment lors de la réservation",
            editDeliveryRequest: {
                caption: 'Avez-vous besoin d’ajuster le calendrier de livraison ?',
                button: 'Modification du calendrier de livraison',
            },
        },
        deliveryRequests: {
            title: 'Liste de demandes de livraison',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: 'Détail de la demande de livraison',
            basicInfo: 'Informations générales',
            editForm: 'Modifier le formulaire',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: 'Livraison possible',
            delivered: 'Livraison déjà complète',
            delivering: 'Livraison en cours',
        },
        offerListForum: {
            translateMessage: 'Traduire le message',
            changeTranslationLanguage: 'Changer la langue',
            languages: {
                en: 'Anglais',
                es: 'Espagnol',
                ja: 'Japonais',
                zh: 'Chinois',
                ko: 'Coréen',
            },
        },
        monthlyClosing: {
            title: 'Liste des clôtures mensuelles',
            createButton: 'Clôtures mensuelles',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: 'Base',
        },
        invoicePayment: {
            title: 'Paiement de la facture « {{invoiceTitle}} »',
            suspendedMessage: "I'm very sorry\n\nWe regret to inform you that we are temporarily suspending credit card payments due to the migration of our payment system.\nPlease wait a while for the migration process. Please make your payment after the migration of the payment system is completed. Or if you are in a hurry, please make your payment by bank transfer.\n",
        },
        transportToWarehouse: {
            waterActivity: "Activité de l'eau",
            moistureContent: 'Teneur en humidité',
        },
        adminAuction: {
            title: 'Statut des enchères de {{offerListName}} / {{lotNumber}}',
            auctionClosed: 'Ces enchères ont déjà été terminées',
            auctionOpened: 'Ces enchères sont ouvertes',
            closeAuction: 'Terminer les enchères',
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: 'Liste de lots adjugés',
        },
        roasterAuction: {
            title: 'Résultats des enchères de {{offerListName}} / {{lotNumber}}',
            bidQuantity: 'Quantité adjugée',
            roasterAuctionResult: "Vos résultats d'adjudication",
            auctionResult: "Tous les résultats d'adjudication",
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Stock',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Stock pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Stock sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: 'Liste des informations de compte bancaire',
            edit: 'Éditer des informations de compte bancaire',
            new: 'Inscrire des informations de compte bancaire',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'Notre sélection',
            order: 'Voir en détail le contenu de la réservation',
            sampleOrderPeriod: 'Always',
            orderPeriod: 'Always',
            paymentPeriod: 'Payment after delivery',
            estimatedDeliveryPeriod: 'About one week after order',
            sampleOrder: 'Click here to request a sample',
            orderFormStepper: {
                order: 'Adresse de paiement et de facturation',
                deliveryRequest: 'Détermination de la livraison',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: 'La date de livraison déterminée est vide',
                        body2: 'Veuillez déterminer une date de livraison',
                    },
                    installment: {
                        body1: 'Il reste des lots dont la demande de livraison est possible',
                        body2: 'Veuillez déterminer toutes les périodes de livraison pour la livraison en plusieurs fois',
                    },
                },
                isNotWarehousing: {
                    body1: 'Pas encore en stock',
                    body2: 'Vous pouvez uniquement déterminer la période de livraison pour les lots qui sont en stocks',
                },
                inValidDeliveryRequestItemsAndRequestDate: 'Veuillez saisir le nombre de livraisons et la date de livraison déterminée',
            },
        },
        preOrderRequest: {
            title: 'Liste des demandes de commande répétée',
            new: 'Créer une demande de commande répétée',
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: 'Demander à partir de la même liste d’offres',
        },
        roasterAddresses: {
            title: 'Gestion du carnet d’adresses',
            billingAddresses: 'Adresse de facturation',
            deliveryAddresses: 'Adresse de livraison',
        },
        cuppingComments: {
            title: 'Résumé du cupping',
            commentedBy: 'Contribution de',
            otherRoasters: 'Et {{ count }} autres torréfacteurs',
        },
        createCuppingComment: {
            title: 'Rédiger un commentaire',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: 'Détermination de la livraison',
            subheaders: {
                oneTime: 'La livraison groupée sera effectuée pendant la période de livraison estimée.',
                installment: 'La livraison sera effectuée en 3 fois au maximum pendant la période de livraison estimée.',
                installmentCaption: 'Livraison estimée : environ 1 semaine après la réservation',
            },
            type: {
                oneTime: 'Livraison groupée',
                installment: 'Livraison en plusieurs fois',
            },
            changeTimings: 'Changer pour {{ timing }}',
            buttons: {
                new: 'Réglage de la période de livraison',
                add: 'Ajout d’une période de livraison',
            },
            captions: {
                datePicker: {
                    fastestDelivery: "* S'il n'est pas renseigné, la livraison sera effectuée dans le délai le plus court possible.",
                    main: {
                        deliveryDateExplanation: '* Vous pouvez déterminer une période comprise entre {{ startWeek }} à partir d’aujourd’hui et 5 mois après la demande de livraison.',
                        startWeek1: '1 semaine',
                        startWeek2: '2 semaines',
                    },
                    sub: {
                        europe: '* En ce qui concerne la date de livraison déterminée, comme la date d’expédition réelle peut être retardée d’environ 2 semaines en fonction des régions, nous vous recommandons de déterminer une date de livraison précoce. Merci de votre compréhension.',
                        etc: '* En ce qui concerne la date de livraison déterminée, comme la date d’expédition réelle peut être retardée d’environ 1 semaine en fonction des régions, nous vous recommandons de déterminer une date de livraison précoce. Merci de votre compréhension.',
                    },
                },
                card: '* Nous vous recommandons une livraison groupée afin que vous puissiez la recevoir dans un état de fraîcheur. Vous pouvez sélectionner une livraison en plusieurs fois à votre convenance.',
            },
            dialog: {
                title: 'Période de livraison',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
    },
    labels: {
        stock: 'Quantité',
        stockUnit: 'Commission',
        lotRef: 'LOT',
        offerListSummary: "Aperçu de l'offre",
        farmWithLink: 'Ferme',
        curatorName: 'Nom de curateur',
        seller: 'Vendeur',
        material: 'Matériaux',
        story: 'Histoire',
        period: "Durée de l'offre",
        activeOfferLists: 'Offres en cours',
        preparingOfferLists: 'Offres en préparation',
        expiredOfferLists: 'Offres terminées',
        noData: 'Données introuvables',
        paymentTimingOnAdmin: 'Calendrier des paiements',
        fullAddress: 'Adresse',
        deliveryItems: 'Liste de livraison (Lot : quantité)',
        all: 'Tout',
        inStock: 'En stock',
        forum: 'Forum',
        forumDisplayName: 'Nom à afficher sur le panneau',
        taxed: 'Taxable',
        paymentTimingHandlingFee: {
            negativeValue: 'Remise',
            positiveValue: 'Commission',
        },
        paid: 'Payé',
        exported: "À l'exportation",
        imported: "À l'importation",
        uploadContract: 'Veuillez sélectionner le contrat que vous voulez télécharger',
        uploadDocuments: 'Veuillez sélectionner des documents à charger',
        uploadBusinessNumberKrdocument: 'Veuillez sélectionner un fichier image',
        selectFoundingCurator: 'Input Founding curator name',
        pending: 'Indéterminée',
        newRoasterCampaignDiscount: 'Remise exceptionnelle sur le premier achat',
        couponTarget: 'Coupon appliqué',
        newRoasterCampaignUnderway: 'Promo for first-time users!',
        agree: 'Agree',
        memo: 'Mémo',
        tradeCountryUsages: 'Utilisation',
        tradeCountryProcessings: 'Procédé/méthode de raffinage',
        tradeCountryPriceRanges: 'Fourchette de prix',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: '* La participation à OKAGESAMA a été complétée',
        default: 'Par défaut',
        billingAddress: 'Adresse de facturation',
        deliveryAddress: 'Adresse de livraison',
        deliveryRequestFormRequestDate: 'Date de livraison déterminée',
        fastestDeliveryRequest: 'Livraison la plus rapide',
        deliveryRequestByDate: 'Livraison à la date fixée',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: 'Autres frais*2',
        taxNodeForJpCalculation: '*1 est soumis à une taxe de 8 %/*2 est soumis à une taxe de 10 %/*3 est défiscalisé',
    },
    buttons: {
        yes: 'Oui',
        no: 'Non',
        create: 'Créer',
        update: 'Mettre à jour',
        delete: 'Supprimer',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: 'Terminer',
        resetPassword: 'Réinitialiser votre mot de passe',
        changePassword: 'Modifier votre mot de passe',
        reconfirmEmail: 'Envoyer un courriel de confirmation',
        chooseFile: 'Sélectionnez un fichier',
        upload: 'Télécharger',
        calculateFixed: 'Fixer le prix final',
        cancelFixed: 'Annuler le prix final que vous avez fixé',
        pay: 'Marquer comme confirmé',
        unpay: 'Effacer le statut "paiement confirmé"',
        downloadInvoice: 'Télécharger la facture',
        salesContractDownloadPdf: 'Télécharger le Sales Contract',
        auctionBonusInvoiceDownloadPdf: 'Télécharger la Auction Bonus Invoice',
        downloadCsv: 'Télécharger le fichier CSV',
        deliveryRequest: 'Demander une livraison',
        processing: 'Traitement en cours',
        import: 'Importer',
        addItem: 'Add Item',
        createContracts: 'Créer un contrat',
        changeStatusTo: 'Changer le statut à {{status}}',
        setBankAccount: 'Configurer des informations de compte bancaire',
        bankAccount: 'Informations de compte bancaire',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: 'Payer',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: 'Voir en détail le contenu de la réservation',
        setAsDefault: 'Définir par défaut',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: 'Suivant',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: 'Pour vous connecter, cliquez ici',
        register: 'Pour créer un compte, cliquez ici',
        resetPassword: 'Vous avez oublié votre mot de passe  Cliquez ici',
        reconfirmEmail: 'Pour renvoyer un courriel de confirmation, cliquez ici',
        back: 'Retour',
        payFromHere: 'Pour effectuer un paiement, cliquez ici',
        story: 'Histoire',
        movie: 'Film',
        privacy_policy: 'Politique de confidentialité',
        specified_commercial_transactions_law: 'Loi japonaise sur les transactions commerciales spécifiques',
        tos: "Conditions d'utilisation",
        trackingUrl: 'Statut des colis',
        cookiePolicy: 'Politique de cookies',
    },
    messages: {
        registerSuccess: "Nous vous avons envoyé un courriel à {{ email }} pour confirmer la validité de votre adresse électronique. Veuillez suivre le lien dans l'Email pour compléter votre inscription.",
        confirmationSuccess: "Nous avons vérifié l'authentification de votre adresse électronique. Veuillez vous connecter avec l'adresse et le mot de passe que vous avez enregistrés.",
        unlockSuccess: 'Le compte a été débloqué.',
        resetPasswordSuccess: 'La demande de la réinitialisation de votre mot de passe a été acceptée. Nous vous contacterons par courriel.',
        accountUpdateSuccess: 'La demande de la modification des informations de votre compte a été acceptée. Nous vous contacterons par courriel.',
        changePasswordSuccess: 'Votre mot de passe a été modifié.',
        reconfirmEmailSuccess: "La demande du renvoi d'un courriel de confirmation a été acceptée. Nous vous contacterons par courriel.",
        invalidEmail: 'Veuillez saisir une adresse électronique valide',
        invalidPostalCode: 'Veuillez saisir uniquement des chiffres pour le code postal',
        loginSuccess: 'Vous êtes connecté',
        logoutSuccess: 'Vous êtes déconnecté',
        uploadSuccess: 'Le téléchargement du fichier CSV a été modifié',
        createSuccess: 'La création a été effectuée',
        updateSuccess: 'La mise à jour a été faite',
        deleteSuccess: 'La suppression a été effectué',
        updateFailure: 'Fehlgeschlagen',
        deleteConfirm: 'Vous allez le supprimer. Souhaitez-vous continuer?',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: 'Vous allez annuler des lots que vous avez adjugés. Êtes-vous sûr?',
        orderSuccess: 'La commande a été faite',
        typicaStockOrderSuccess: 'Order successful. You can request delivery from the warehouse stock list for items already in stock.',
        sampleOrderSuccess: "L'échantillon a été réservé",
        deliveryRequestSuccess: 'La demande a été envoyée. Nous vous contacterons dès que la livraison de votre colis sera prêt',
        cancelConfirm: "L'annulation ne peut pas être annulée, souhaitez-vous continuer?",
        calculateFixed: "Vous allez approuver la demande de r\u00E9servation du torr\u00E9facteur et conclure le contrat de vente.\nVeuillez v\u00E9rifier que le prix est correct. Souhaitez-vous continuer?",
        calculateFixedSuccess: 'Le prix final pour la réservation en question a été fixé.',
        cancelFixed: "Vous allez rompre le contrat de vente avec le torr\u00E9facteur qui a d\u00E9j\u00E0 \u00E9t\u00E9 conclu.\nrupture du contrat comporte des risques. Souhaitez-vous continuer?",
        cancelFixedSuccess: 'La fixation du prix final a été annulée.',
        commentSuccess: 'Vous avez laissé un commentaire.',
        deleteCommentConfirmTitle: 'Supprimer le commentaire',
        deleteCommentConfirmBody: 'Vous allez supprimer le commentaire. Souhaitez-vous continuer?',
        changePasswordTokenError: 'Le délai de réinitialisation votre mot de passe a déjà été dépassé. Veuillez le réinitialiser à nouveau.',
        deleteInvoiceConfirmTitle: 'Supprimer la facture',
        deleteInvoiceConfirmBody: 'Vous allez supprimer la facture. Souhaitez-vous continuer?',
        deleteInvoiceItemConfirmTitle: 'Supprimer le relevé de facturation',
        deleteInvoiceItemConfirmBody: 'Vous allez supprimer le relevé de facturation. Souhaitez-vous continuer?',
        sendInvoiceMailConfirmTitle: 'Informer par courriel',
        sendInvoiceMailConfirmBody: "Vous allez envoyer un courriel afin d'informer au torréfacteur que la facture a été émise. Souhaitez-vous continuer?",
        sentSuccess: 'Un courriel a été envoyé.',
        payConfirmTitle: 'Marquer comme confirmé.',
        payConfirmBody: 'Vous allez marquer comme confirmé. Souhaitez-vous continuer?',
        unpayConfirmTitle: 'Retirer le statut "confirmé"',
        unpayConfirmBody: 'Vous allez retirer le statut "confirmé". Souhaitez-vous continuer?',
        nRowsSelected: '{0} liste(s) est sélectionnée.',
        noDeliveryRequest: 'Aucune demande de livraison',
        invalidOrderCombination: 'Vous ne pouvez pas demander des échantillons et faire la réservation en même temps.',
        orderExplanationTitle: 'Conditions sur la réservation',
        sampleOrderExplanationTitle: "Notes sur les demandes d'échantillons",
        auctionOrderExplanationTitle: 'Consignes des réservations aux enchères',
        sampleOrderExplanationBody: "Le nombre d'\u00E9chantillons est limit\u00E9, donc les demandes d'\u00E9chantillons sont r\u00E9serv\u00E9es aux gens qui ach\u00E8tent des produits.\nNous organisons aussi des cuppings communautaires dans le monde entier o\u00F9 vous pouvez exp\u00E9rimenter l'ensemble des produits.\nVeuillez consulter l'annonce par mail pour plus de d\u00E9tails.",
        deliveryTimeExplanationTitle: 'Conditions de livraison',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* Des frais de port domestique seront ajout\u00E9s.\n* Il est possible que des retards de livraison des marchandises se produisent selon des conditions de circuit de distribution.\n* N\u2019h\u00E9sitez pas \u00E0 nous contacter si vous avez des questions.\n* Des frais additionnelles seront ajout\u00E9es lors de la livraison depuis notre entrep\u00F4t aux Pays-Bas.\n* Notre partenaire de livraison, CTS Group livre votre commande \u00E0 votre torr\u00E9facteur.\n* Veuillez consulter <0>cette fiche</0> pour les frais de livraison.\n* Des emballages de plus de 23 kg seront mis sur une palette en respectant le r\u00E8glement de l'UE.\n* Rien ne sera empil\u00E9 sur des emballages de caf\u00E9 achet\u00E9 (non stockable), donc des frais de livraison seront calcul\u00E9s \u00E0 la base de 3/4 europallet.",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n    * Pre-order pricing is ex-warehouse.\n    There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    Please see <1>this file</1> for delivery costs by destination in NYC area.\n    Kindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n    * An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n    * The quality of the product shall be the same as the sample.\n\n    * As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* Veuillez lire les <0>Conditions g\u00E9n\u00E9rales d'utilisation</0> avant de faire une r\u00E9servation.\n\n* Des frais additionnelles seront ajout\u00E9es lors de la livraison depuis notre entrep\u00F4t aux Pays-Bas. Veuillez consulter <1>cette fiche</1> pour les frais de livraison.\n\n* Il est possible que des retards de livraison des marchandises se produisent selon des conditions de production et de transport.\n\n* La qualit\u00E9 du produit doit \u00EAtre conforme \u00E0 celle de l'\u00E9chantillon.\n\n* \u00C9tant donn\u00E9 que la production de grains de caf\u00E9 vert est fortement influenc\u00E9e par les conditions et le climat de la zone de production, des changements de conditions peuvent se produire. Cette r\u00E9servation ne garantit donc pas que votre commande sera honor\u00E9e. TYPICA vous contactera \u00E0 la fin de la p\u00E9riode de r\u00E9servation pour vous informer si votre commande a \u00E9t\u00E9 honor\u00E9e ou non.",
        createdInvoices: '{{count}} facture(s) a été émise.',
        orderNotStarted: 'Les réservations sont ouvertes à partir du {{ startedAt }}',
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\n  Please make sure that you have not forgotten to create TYPICA Stock.\n  Do you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: 'Afin de télécharger le Sales Contract',
        salesContractDownloadExplanationBody: "Avant de t\u00E9l\u00E9charger le SalesContract, vous devez configurer des informations de votre compte bancaire.\nVeuillez remplir cette formule et laisser des notes pour des informations suppl\u00E9mentaires le cas \u00E9ch\u00E9ant.",
        addBankAccountInformation: "Afin de t\u00E9l\u00E9charger le SalesContract, vous devez configurer des informations de votre compte bancaire.\nVeuillez enregistrer des informations de votre compte bancaire.",
        createBankAccount: "L'information sur le compte bancaire a été créée",
        orderedOfferNotExist: "Il n'y a pas encore de Lot réservé",
        stripeConfirmBody: 'Le paiement va être effectué. Confirmer ?',
        updateSuccessInvoicePaid: 'Le paiement est terminé. Un certain temps peut s’écouler avant que le paiement de la facture soit indiqué comme complété. Nous vous remercions de votre compréhension.',
        deliverySampleWarningMessage: 'Nous vous enverrons les échantillons une fois que nous aurons reçu les produits en magasin. La date de réception prévue en magasin est le {{ approvalDate }}.',
        deliverySampleWarningConfirmationMessage: 'Nous vous enverrons les échantillons suivants une fois que nous aurons reçu les produits en magasin.',
        contactToTypicaMessage: 'Veuillez nous contacter en utilisant l’adresse électronique suivante.',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: 'Nous avons migré vers la nouvelle plateforme à partir du 6 août 2024. Si vous souhaitez vous inscrire en tant que nouvel utilisateur, veuillez vous inscrire à partir de <0>Cliquez ici</0>.',
        newPlatformNotice: 'Nous migrerons vers la nouvelle plateforme à partir du 6er août 2024. Veuillez utiliser <0>ici</0>.',
        newPlatformSampleNotice: "Une liste d'exemples de demandes pour la nouvelle plate-forme est <0>Cliquez ici</0>.",
        newPlatformOrderNotice: 'La liste de réservation pour la nouvelle plateforme est <0>Cliquez ici</0>.',
        newPlatformInvoiceNotice: 'La facture de la nouvelle plateforme est <0>Cliquez ici</0>.',
        newPlatformProfileNotice: "Les informations mises \u00E0 jour ici ne seront pas automatiquement transf\u00E9r\u00E9es sur la nouvelle plateforme.\nNous nous excusons pour la g\u00EAne occasionn\u00E9e, mais veuillez \u00E9galement mettre \u00E0 jour vers la <0>Nouvelle plate-forme</0>.",
    },
    errors: {
        isRequired: 'Veuillez saisir {{ field }}',
        invalid: '{{ field }} est une valeur invalide',
        positive: '{{ field }} doit être supérieur ou égal à 1',
        integer: '{{ field }} doit être un (des) chiffres',
        decimal: '{{ field }} doit être un (des) chiffres et .(point décimal)',
        alphanumeric: '{{ field }} doit être en alphanumérique',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: "La quantité maximale d'achat de ce lot est {limit}}",
        lowestBidFobPriceError: 'Le montant indiqué est inférieur au prix initial',
        totalFeeUpperLimitError: 'Il dépasse le plafond de votre carte de crédit. Veuillez changer le mode de paiement au virement bancaire ou régler pour que le montant de votre achat soit moins de huit chiffres.',
        noStock: 'Rupture de stock.',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: 'Veuillez saisir un poids supérieur ou égal à {{ minOrder }} unités de commande du lot',
        notSelectableLessThanOrdersTotalWeight120Kg: 'Vous pouvez sélectionner une réservation à partir de 120 kg',
    },
    options: {
        isExists: {
            '1': 'Oui',
            '0': 'Non',
        },
        isQGrader: {
            '1': 'Je possède la licence Q Grader',
            '0': 'Je ne possède pas la licence Q Grader',
        },
    },
    stripePayment: {
        failure: 'Le paiement a échoué. Veuillez reprendre depuis le début.',
        afterStatusSucceeded: 'Le paiement a déjà été effectué. Un certain temps peut s’écouler avant que le paiement soit indiqué comme complété. Nous vous remercions de votre compréhension.',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
};
